import { render, staticRenderFns } from "./PermissionsCardCreate.vue?vue&type=template&id=86120ad2"
import script from "./PermissionsCardCreate.vue?vue&type=script&lang=js"
export * from "./PermissionsCardCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports